import { MouseEvent, useEffect, useState, } from 'react';
import { FaTrash } from 'react-icons/fa';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { RoleBinding } from '../../types';
import { CreateUserRoleBindingModal } from './CreateUserRoleBindingModal';
import { selectCurrentTenantId } from '../user/userSlice';
import {
  listRoleBindingsAction,
  selectUserRoleBindings,
  deleteRoleBindingAction,
} from './roleBindingSlice';

type Props = {
  role_id: string;
};

export function UserRoleBindingTable({ role_id }: Props) {
  const dispatch = useAppDispatch();
  const roleBindings = useAppSelector(selectUserRoleBindings);
  const tenantId = useAppSelector(selectCurrentTenantId);
  const [show_modal, setShowModal] = useState(false);

  useEffect(() => {
    dispatch(listRoleBindingsAction({ tenant_id: tenantId, role_ids: [role_id] }));
  }, [tenantId, role_id, dispatch]);

  const handleOpenModal = async() => {
    setShowModal(true);
  };

  const handleCloseModal = async() => {
    setShowModal(false);
    dispatch(listRoleBindingsAction({ tenant_id: tenantId, role_ids: [role_id] }));
  };

  const handleDeleteRoleBinding = async(e: MouseEvent, role_binding: RoleBinding) => {
    e.preventDefault();
    await dispatch(deleteRoleBindingAction({
      tenant_id: tenantId,
      body: { id: role_binding.id },
    }));
    dispatch(listRoleBindingsAction({ tenant_id: tenantId, role_ids: [role_id] }));
  };

  return (
    <div className="role-binding-list mt-3">
      <div className="d-flex justify-content-between py-4">
        <h3>{roleBindings.length || 'No'} assigned users</h3>
        <button className="btn btn-primary my-2" onClick={handleOpenModal}>
          Create
        </button>
      </div>
      <table className="table">
        <thead className="table-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col">UserTenantId</th>
            <th scope="col">UserId</th>
            <th scope="col">UserName</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {roleBindings.map((role_binding, index) => {
            return (
              <tr key={index}>
                <th scope="row">{ index+1 }</th>
                <td>{role_binding.user_tenant_id}</td>
                <td>{role_binding.user_id}</td>
                <td>{role_binding.user_name}</td>
                <td>
                  <a href="/#" className="text-danger" role="button"
                    onClick={(e) => handleDeleteRoleBinding(e, role_binding)}>
                    <FaTrash />
                  </a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <CreateUserRoleBindingModal
        tenant_id={tenantId}
        role_id={role_id}
        show={show_modal}
        onClose={handleCloseModal}
      />
    </div>
  );
}
